import { useQuery } from '@tanstack/react-query';
import { issueDetailApi, IssueDetail } from '../api/issueDetailApi';

export const useIssueDetail = (issueKey?: string) => {
  const { data: issue, isLoading, error } = useQuery<IssueDetail>({
    queryKey: ['issue-detail', issueKey],
    queryFn: () => issueDetailApi.fetchIssueDetail(issueKey as string),
    enabled: !!issueKey,
    retry: false,
  });

  return { issue, isLoading, error: error as Error | null };
};
